const LEGACY_UPLOAD_NAME = /\/files\/\d{12}-([^/]+)$/;

export const getUploadedFileName = (fileUrl: string): string =>
  LEGACY_UPLOAD_NAME.exec(fileUrl)?.[1] ?? fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
